module.exports = __webpack_public_path__ + "static/RussellB-f909f64470e63c531c83d9f85c11abb7.gif";